/* eslint-disable camelcase */
/**
 * @author Daniel Aguirre
 * @file index.js
 * @description Appointments Services
 */

// Core
import endpoints from '@nephro/config/endpoints';
import { externalConnector } from '@nephro/core/connector';

// Endpoints
const { appointmentsZoom: appointmentsZoomEndpoints } = endpoints;

export class AppointmentsZoomService {
  constructor(http) {
    this.http = http;
  }

  /**
   * Schedule selected appointment
   * @param {Date} cap_horainicio - appointment initial time
   * @param {number} id - id
   * @param {String} profesional - Professional
   * @param {number} tipoConsultaId - Consult type id
   * @param {number} idPatient - id patient Nephro+
   * @param {number} idPatientAm - id patient in agendamate
   * @returns { Object } - scheduled appointment.
   */
  scheduleAppointmentZoom = async (
    cap_horainicio,
    id,
    profesional,
    tipoConsultaId,
    idPatient,
    idPatientAm
  ) => {
    let url = appointmentsZoomEndpoints.scheduleAppointment;
    const body = {
      cap_horainicio,
      id,
      profesional,
      tipoConsultaId
    };
    url = `${url}?idPatient=${idPatient}&idPatientAm=${idPatientAm}`;
    return this.http.post(url, body);
  };

  /**
   * ReSchedule selected appointment
   * @param {Date} cap_horainicio - appointment initial time
   * @param {number} id - id
   * @param {String} profesional - Professional
   * @param {number} tipoConsultaId - Consult type id
   * @param {number} idPatientAm - id patient in agendamate
   * @param {number} quoteId - Id quote to update
   * @return { Object } - Rescheduled appointment.
   */
  reScheduleAppointmentZoom = async (
    cap_horainicio,
    id,
    profesional,
    tipoConsultaId,
    idPatientAm,
    quoteId,
    meetingId
  ) => {
    const body = {
      cap_horainicio,
      id,
      profesional,
      tipoConsultaId
    };
    let url = appointmentsZoomEndpoints.reScheduleAppointment;
    url = `${url}?currentAppointmentId=${quoteId}&idPatientAm=${idPatientAm}&zoomMeetingId=${meetingId}`;
    return this.http.update(url, body, {}, 'put');
  };

  /**
   * Cancel selected appointment
   * @param { number } quoteId - Current quote id.
   * @return { Object } -Get canceled appointment.
   */
  cancelAppointmentZoom = async (quoteId, meetingId) => {
    let url = appointmentsZoomEndpoints.cancelAppointment;
    url = `${url}?quoteId=${quoteId}&zoomMeetingId=${meetingId}`;
    return this.http.delete(url);
  };

  /**
   * Get zoom video call info by appointment id
   * @param { number } quoteId - Current quote id.
   * @return { Object } -Get canceled appointment.
   */
  getZoomVideoCallById = async (quoteId) => {
    let url = appointmentsZoomEndpoints.getZoomVideoCallById;
    url = `${url}/${quoteId}`;
    return this.http.get(url);
  };
}

export default new AppointmentsZoomService(externalConnector);
